export default __webpack_public_path__ + "static/media/Slice 4.dda4345d.svg";